import { Grid } from '@mui/material'
import Accordion from 'components/Common/Accordion/Accordion'
import React from 'react'
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import UploadFile from 'components/Common/ElementInForm/UploadFile/UploadFile';
import { Extension } from 'service/CommonFunction/TS_function';
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import AsyncAutoComplete from 'components/Common/ElementInForm/AsyncAutoComplete';
import DatePickerFormItem from 'components/Common/ElementInForm/DatePickerFormItem';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import AsyncAutoCompleteReferVOC from 'components/Common/ElementInForm/AsyncAutoCompleteReferVOC';
import moment from 'moment';
import TimePickerFormItem from 'components/Common/ElementInForm/TimePickerFormItem';

const OptionIsNoticeEmail = [
    { value: "1", label: "ส่ง" },
    { value: "0", label: "ไม่ส่ง" },
]

const CpnDataClassifyVOC = (props) => {

    const {
        form,
        header,
        arrAttachment,
        setarrAttachment,
        Option,
        onHandleField,
        setIsCheckTel,
        IsCheckTel,
        IsOtherVOCService,
        setIsOtherVOCService,
        setIsOpenMap,
        IsAddAddress,
        setIsAddAddress,
        setsLocation,
        setoLocationCurrent,
        setIsSetMap,
        setisInputTelRequire,
        onClearFile,
        sMode = "",     //classify,complain,request,suggest,view,editall
        BAold,
        setBACurrent,
        UserLoginBA,
        IsReferVOC
    } = props;


    const onHandleChangeValue = (sField, sValue) => {
        switch (sField) {
            case "customer":
                form.setValue("oBA", null)
                form.setValue("oCompany", null)
                form.setValue("oAddress", null)
                form.setValue("sAddress", null)
                form.setValue("oTel", null)
                form.setValue("sInputTel", null)
                setIsAddAddress(false)
                setIsSetMap(false)
                setoLocationCurrent({ lat: null, lng: null })
                setsLocation({
                    Latitude: null,
                    Longitude: null,
                    Address: null,
                })
                form.setValue("oVOCService", null)
                form.setValue("sOtherVOCService", null)
                setIsOtherVOCService(false)
                break;
            case "ba":
                setBACurrent(sValue?.value ?? "")
                form.setValue("oVOCService", null)
                form.setValue("sOtherVOCService", null)
                // form.setValue("sNoticeEmail", "")
                setIsOtherVOCService(false)
                break;
            case "voctype":
                form.setValue("oVOCService", null)
                form.setValue("sOtherVOCService", null)
                setIsOtherVOCService(false)
                break;
            case "company":
                form.setValue("oAddress", null)
                form.setValue("sAddress", null)
                setIsAddAddress(false)
                break;
            case "selectaddress":
                form.setValue("sAddress", null)
                if (sValue && sValue.value === "-1") {
                    setIsAddAddress(true)
                } else {
                    setIsAddAddress(false)
                    setIsSetMap(false)
                }
                break;
            case "inputaddress":
                setIsSetMap(false)
                setoLocationCurrent({ lat: null, lng: null })
                setsLocation({
                    Latitude: null,
                    Longitude: null,
                    Address: null,
                })
                break;
            case "tel":
                form.setValue("sInputTel", null)
                form.clearErrors("sInputTel")
                break;
            default:
                break;
        }

    }

    return (
        <>
            <Accordion header={header}>
                <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                    <Grid item xs={12}>
                        <Grid container spacing={2} direction="row" justifyContent="space-between" alignItems="start" >
                            <Grid item xs={12} sm={3}>
                                <InputFormItem
                                    id="sJobCode"
                                    name="sJobCode"
                                    label="เลขที่ใบงาน"
                                    required={false}
                                    fullWidth
                                    disabled
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Grid container spacing={2} direction="row" justifyContent="end" alignItems="start" >
                                    <Grid item xs={12} sm={5}>
                                        <InputFormItem
                                            id="sVOCFormCode"
                                            name="sVOCFormCode"
                                            label="เลขที่ใบแจ้ง"
                                            required={false}
                                            fullWidth
                                            disabled
                                        />
                                    </Grid>
                                    {
                                        IsReferVOC
                                            ?
                                            <Grid item xs={12} sm={5}>
                                                <AsyncAutoCompleteReferVOC
                                                    name="sReferVOCFormCode"
                                                    sUrlAPI={"VOC/GetVOCRefer"}
                                                    ParamUrl={{
                                                        nCustomerID: form.getValues("oCustomer") ? parseInt(form.getValues("oCustomer").value) : null,
                                                    }}
                                                    label="เลขที่ใบแจ้งอ้างอิง"
                                                    required={true}
                                                    sMethodAxios={"GET"}
                                                    disabled={true}
                                                />
                                            </Grid>
                                            : null
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <AsyncAutoComplete
                            name="oCustomer"
                            sUrlAPI={"User/SearchUser"}
                            label="ลูกค้า"
                            required={true}
                            textSearch={"กรอกชื่อลูกค้า/นามสกุลลูกค้า"}
                            sMethodAxios={"POST"}
                            disabled={true}
                            onChange={(event) => {
                                onHandleField(event, "Customer")
                                onHandleChangeValue("customer", event)

                            }}
                        />
                        {/* <AsyncAutoComplete
                            name="oCustomer"
                            sUrlAPI={"User/SearchCustomer"}
                            label="ลูกค้า"
                            required={true}
                            textSearch={"กรอกชื่อลูกค้า/นามสกุลลูกค้า"}
                            sMethodAxios={"GET"}
                            disabled={true}
                            onChange={(event) => {
                                onHandleField(event, "Customer")
                                onHandleChangeValue("customer", event)

                            }}
                        /> */}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <AutoCompleteSelect
                            name="oBA"
                            options={Option.lstBA ?? []}
                            label={"กลุ่มตลาด"}
                            required={true}
                            disabled={false}
                            onChange={(event) => {
                                onHandleField(event, "BA");
                                onHandleChangeValue("ba", event)
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <AutoCompleteSelect
                            name="oCompany"
                            options={Option.lstCompany ?? []}
                            label={"บริษัท"}
                            required={true}
                            disabled={true}
                            onChange={(event) => {
                                onHandleField(event, "Company")
                                onHandleChangeValue("company", event)
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <AutoCompleteSelect
                            name="oAddress"
                            options={Option.lstCompanyAddress ?? []}
                            label={"ที่อยู่/สถานที่เกิดเหตุ"}
                            required={true}
                            disabled={true}
                            onChange={(event) => {
                                onHandleChangeValue("selectaddress", event)
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ display: IsAddAddress === true ? 'block' : 'none' }}>
                        <InputFormItem
                            id="sAddress"
                            name="sAddress"
                            label="ที่อยู่/สถานที่เกิดเหตุ"
                            required={true}
                            multiline={true}
                            rows={2}
                            fullWidth
                            onChange={(event) => {
                                onHandleChangeValue("inputaddress", event)
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <AutoCompleteSelect
                            name="oVOCType"
                            options={Option.lstVOCType ?? []}
                            label={"ประเภท"}
                            required={true}
                            disabled={false}
                            onChange={(event) => {
                                onHandleField(event, "TypeVOC")
                                onHandleChangeValue("voctype", event)
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <AutoCompleteSelect
                            name="oVOCService"
                            options={Option.lstVOCService ?? []}
                            label={"บริการที่ต้องการ / ปัญหาที่พบ"}
                            required={UserLoginBA.includes(parseInt(form.getValues("oBA")?.value)) ? true : false}
                            disabled={false}
                            onChange={(event) => {
                                // onHandleChangeValue("voctypeservice", event)
                                if (event) {
                                    setIsOtherVOCService(event.IsOther === true ? true : false)
                                }
                                else {
                                    setIsOtherVOCService(false)
                                }
                            }}
                        />
                    </Grid>
                    {IsOtherVOCService == true ?
                        <Grid item xs={12} >
                            <InputCustomLabel
                                id="sOtherVOCService"
                                name="sOtherVOCService"
                                label="บริการที่ต้องการ / ปัญหาที่พบ (อื่นๆ)"
                                maxLength={500}
                                required={true}
                                disabled={false}
                                fullWidth
                            />
                        </Grid>
                        : null
                    }
                    <Grid item xs={12} >
                        <InputCustomLabel
                            id="sDetail"
                            name="sDetail"
                            label="รายละเอียด"
                            required={true}
                            multiline={true}
                            disabled={true}
                            maxLength={1000}
                            rows={4}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" >
                            <Grid item xs={12} sm={6}>
                                <AutoCompleteSelect
                                    name="oTel"
                                    options={Option.lstTel ?? []}
                                    label={"หมายเลขโทรศัพท์"}
                                    required={true}
                                    disabled={true}
                                    onChange={(event) => {
                                        onHandleChangeValue("tel", event)
                                        if (event) {
                                            setisInputTelRequire(event.value === "-1" ? true : false)
                                        } else {
                                            setisInputTelRequire(false)
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: '-16px' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={IsCheckTel}
                                            onChange={() => {
                                                // setIsOpenMap(true)
                                                setIsCheckTel(!IsCheckTel);
                                            }}
                                        />
                                    }
                                    disabled={true}
                                    label="ยินดีให้ติดต่อกลับทางโทรศัพท์"
                                    labelPlacement="end"
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <div style={{ width: '100%', height: '100%', display: arrAttachment.length == 0 ? "none" : "" }}>
                            <UploadFile
                                id="sDocFile"
                                keyID={1}
                                sTitle={"เอกสารแนบ"}
                                IsRequired={false}
                                arrFile={arrAttachment || []}
                                setarrFile={setarrAttachment}
                                IsFolder={false}
                                IsFile={true}
                                IsMultiple={false}
                                disabled={true}
                                IsHiddenUploadBox={true}
                                Extension={[...Extension.PDF, ...Extension.Image, ...Extension.Word, ...Extension.Excel, ...Extension.Other]}
                                IsDrag={false}
                                nLimitFile={10}
                                sLimitFile={"MB"}
                                onClearFile={onClearFile}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{ marginTop: '-32px' }}>
                            <Grid item xs={12} sm={6} md={5}>
                                <DatePickerFormItem
                                    name="sDateIssue"
                                    label="วันที่แจ้ง"
                                    fullWidth={true}
                                    required={true}
                                    disabled={true}
                                    minDate={moment()}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={5}>
                                <TimePickerFormItem
                                    name="sTimeIssue"
                                    label="เวลาที่แจ้ง"
                                    fullWidth={true}
                                    required={true}
                                    disabled={true}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Accordion>
        </>
    )
}

export default CpnDataClassifyVOC